import { TypeForm } from '@/containers/OwnBusinessForm/OwnBusinessForm';
import { createActionCreator } from 'deox';

export const postNotificationActions = {
  request: createActionCreator(
    'POST_NOTIFICATION_REQUEST',
    (resolve) => (email: string, entityId: string, message: string, name: string, phone: string, type: TypeForm) =>
      resolve({ email, entityId, message, name, phone, type })
  ),
  success: createActionCreator('POST_NOTIFICATION_SUCCESS'),
  failure: createActionCreator('POST_NOTIFICATION_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
